{
  "confirmationNumber": "確認號碼 {number}",
  "dateTimeRange": "{date}，{startTime} 至 {endTime}"
}
